import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=c27f1c9c&scoped=true&"
import script from "./RadioButton.vue?vue&type=script&lang=js&"
export * from "./RadioButton.vue?vue&type=script&lang=js&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=c27f1c9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27f1c9c",
  null
  
)

export default component.exports